import {Tax} from "@app/core/delivery-point/application/dtos/tax";

export interface DeliveryPoint {
    code: number,
    name: string,
    address: string,
    postalCode: string,
    city: string,
    province: string,
    language: string,
    paymentMethod: string,
    warehouse: string,
    priceHidden: boolean,
    blocked: boolean,
    nif: string,
    tax: Tax;
    clientType: DeliveryPointClientType;
}

/**
 * The type of client that uses the delivery point.
 */
export enum DeliveryPointClientType {
    CUSTOMER,
    EMPLOYEE,
}